/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { getFooterContactsByPartner } from '@features/payment/payment-form';
import { generateUuid, withTheme } from '@shared/lib';
import { usePartner } from '@shared/lib/partner';
import { Content } from '@shared/ui/atoms';
import ContactInfo from './ContactInfo';
interface FooterProps {
  isWebView?: boolean;
}
const OldFooter: FC<FooterProps> = ({
  isWebView
}) => {
  const router = useRouter();
  const {
    partner
  } = usePartner();
  const isPayQRPage = router.asPath.includes('pay-qr');
  const isPubgGiveawayPage = router.asPath === '/rozygrysh-prizov-pubg-mobile';
  const isPubgGiveawayResultsPage = router.asPath === '/rozygrysh-prizov-pubg-mobile-itogi';
  const isVesenniiRozygrysh2026Page = router.asPath === '/vesennii-rozygrysh-prizov-2026';
  const isDvoinoiShansNaPobeduPage = router.asPath.includes('dvoinoi-shans-na-pobedu');
  const isDvoinoiShansNaPobeduResultsPage = router.asPath.includes('dvoinoi-shans-na-pobedu-itogi');
  if (isWebView) return null;
  return <FooterWrapper isPayQRPage={isPayQRPage} isPubgGiveawayPage={isPubgGiveawayPage} isPubgGiveawayResultsPage={isPubgGiveawayResultsPage} isVesenniiRozygrysh2026Page={isVesenniiRozygrysh2026Page} isDvoinoiShansNaPobeduPage={isDvoinoiShansNaPobeduPage} isDvoinoiShansNaPobeduResultsPage={isDvoinoiShansNaPobeduResultsPage}>
      <Content.Padding left={64} right={64} mobLeft={24} mobRight={24} minLeft={20} minRight={20}>
        <ContentWrapper isPayQRPage={isPayQRPage}>
          <ContactsWrapper>
            {(getFooterContactsByPartner(partner) as any).map(({
            contact,
            region,
            icon
          }) => <ContactInfo key={generateUuid()} contact={contact} region={region} icon={icon} />)}
          </ContactsWrapper>
        </ContentWrapper>
      </Content.Padding>
    </FooterWrapper>;
};
export default OldFooter;
interface ContentWrapperProps {
  isPayQRPage: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isPayQRPage
}) => isPayQRPage ? '1500px' : '1016px';
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSText;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp5 = /*#__PURE__*/() => ({
  isPayQRPage
}) => isPayQRPage ? 'auto' : '644px';
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1ntoy3p",
  propsAsIs: false,
  vars: {
    "c1ntoy3p-0": [_exp()],
    "c1ntoy3p-1": [_exp2()],
    "c1ntoy3p-2": [_exp3(), "px"],
    "c1ntoy3p-3": [_exp4()],
    "c1ntoy3p-4": [_exp5()]
  }
}));
interface FooterWrapperProps {
  isPayQRPage: boolean;
  isPubgGiveawayPage: boolean;
  isPubgGiveawayResultsPage: boolean;
  isVesenniiRozygrysh2026Page: boolean;
  isDvoinoiShansNaPobeduPage: boolean;
  isDvoinoiShansNaPobeduResultsPage: boolean;
}
const _exp6 = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage,
  isPubgGiveawayResultsPage,
  isVesenniiRozygrysh2026Page,
  isDvoinoiShansNaPobeduPage,
  isDvoinoiShansNaPobeduResultsPage,
  theme
}) => isDvoinoiShansNaPobeduPage || isDvoinoiShansNaPobeduResultsPage ? '#713F23' : isPayQRPage ? '#1D2023' : isPubgGiveawayPage || isPubgGiveawayResultsPage ? '#222222' : isVesenniiRozygrysh2026Page ? '#102248' : theme.colors.bg.footer;
const _exp7 = /*#__PURE__*/() => ({
  isPayQRPage,
  isPubgGiveawayPage
}) => isPayQRPage ? '92px' : isPubgGiveawayPage ? '92px' : '0';
const FooterWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "fzuznc1",
  propsAsIs: false,
  vars: {
    "fzuznc1-0": [_exp6()],
    "fzuznc1-1": [_exp7()]
  }
}));
const ContactsWrapper = /*#__PURE__*/styled('div')({
  name: "ContactsWrapper",
  class: "cw05fg9",
  propsAsIs: false
});

require("./OldFooter.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldFooter.tsx");